let MOTOHeight = 50;
let headerHeightArc = 0;

let hasSpawnedHeader = false;
let headerSpawnHeight = 0;

let scrollAmount = 0;
let canUseStickyHeader = false;
let onMOTOPage = true;

let whiteListedSHPages = ['/', "/collections", "/blogs/news/", "/blogs/upcoming/", "/products", "/search", "/pages/privacy-policy", "/pages/terms-of-service"]; //Pages that the header will stick on
//let MOTOPages = ['/', "/collections", "/pages/categories"]; //Pages that the header & MOTO are on

for (let i = 0; i < whiteListedSHPages.length; i++)
{
    if(window.location.pathname == whiteListedSHPages[i] || (whiteListedSHPages[i].length > 1 && window.location.pathname.includes(whiteListedSHPages[i])))
    {
        canUseStickyHeader = true;
        break;
    }
}

/*for (let i = 0; i < MOTOPages.length; i++)
{
    if(window.location.pathname == MOTOPages[i])
    {
        onMOTOPage = true;
        break;
    }
    
}*/

let headerSpawnOffset = onMOTOPage ? 300 : 250;

function spawnHeader(headerElm)
{
    if (scrollAmount < document.documentElement.scrollHeight - 750)
    {
        headerHeightArc = 0;
    
        hasSpawnedHeader = true;
    
        let pageScrollAmount = window.pageYOffset;
        headerSpawnHeight = pageScrollAmount - headerElm.getBoundingClientRect().height - headerSpawnOffset;
        
        headerElm.style.position = "absolute";
        headerElm.style.top = `${headerSpawnHeight}px`;
    }
}

function checkHeaderState(headerElm)
{
    let headerHeightMOTOOffset = onMOTOPage ? 48 : 0;

    headerHeightArc = window.pageYOffset + headerElm.getBoundingClientRect().top - headerHeightMOTOOffset;

    if(headerElm.getBoundingClientRect().top >= 1.5)
    {
        headerElm.style.position = "fixed";
        headerElm.style.top = "0px";
    }else if(headerElm.getBoundingClientRect().top <= -360)
    {
        hasSpawnedHeader = false;
    }
}

function abandonHeader(headerElm)
{    
    let headerSpacer = document.getElementsByClassName("headerSpacer")[0];
    
    headerElm.style.position = "absolute";
    headerSpacer.style.display = "block";
    headerElm.style.top = `${headerHeightArc}px`;

    if(headerElm.getBoundingClientRect().top >= -104)
    {
        hasSpawnedHeader = false;
    }
}

function dockHeader(headerElm)
{
    let headerSpacer = document.getElementsByClassName("headerSpacer")[0];

    headerElm.style.position = "relative";
    headerElm.style.top = `auto`;

    headerSpacer.style.display = "none";

    hasSpawnedHeader = false;
}

function departHeader(headerElm, changeSpawnHeader)
{
    if(onMOTOPage || screen.width <= 500)
    {
        hasSpawnedHeader = scrollAmount < changeSpawnHeader - 15 ? true : false;

        let headerSpacer = document.getElementsByClassName("headerSpacer")[0];
    
        headerElm.style.position = "fixed";
        headerElm.style.top = "0px";
    
        headerSpacer.style.display = "block";
        headerHeightArc = window.pageYOffset + headerElm.getBoundingClientRect().top - 48;
    }else if(scrollAmount > headerElm.getBoundingClientRect().height + 50)
    {
        abandonHeader(headerElm);
    }
}

if(canUseStickyHeader || screen.width <= 500)
{
    window.addEventListener("scroll", function()
    {
        let headerElm = document.getElementById("headerDiv");
    
        let isUpScroll = this.oldScroll > this.scrollY;
        this.oldScroll = this.scrollY;
        
        scrollAmount = this.scrollY;

        let whiteListPageTest = false;
    
        let headerStayDropDownAmount = 686; /* The amount the header will stay dropped down too */
        let headerStayDropDownAmountOffset = headerElm.getBoundingClientRect().height + headerSpawnOffset; /* How far the header will stay before departing from the top */
    
        whiteListPageTest = onMOTOPage && scrollAmount < MOTOHeight;

        if(scrollAmount < (document.body.scrollHeight - 1000))
        {
            if(whiteListPageTest)
            {
                dockHeader(headerElm);
            }else if(scrollAmount != 0)
            {
                if((isUpScroll && scrollAmount > MOTOHeight) && screen.width > 500)
                {
                    if(!hasSpawnedHeader && scrollAmount > headerStayDropDownAmount + headerStayDropDownAmountOffset)
                    {
                        spawnHeader(headerElm);
                    }else
                    {
                        checkHeaderState(headerElm);
                    }
                }else
                {
                    if((scrollAmount > headerStayDropDownAmount) && screen.width > 500)
                    {
                        abandonHeader(headerElm);
                    }else
                    {
                        departHeader(headerElm,headerStayDropDownAmount);
                    }
                }
            }else
            {
                dockHeader(headerElm);
            }
        }
    }); 
}